import React from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { useMorningDashBoardCardHeaderStyles } from './CardHeader.styles';
import { devComponentName } from '@morning-dashboard/helpers/isDevEnv';
import { getTodayDate } from '@widgets/helpers';
import { useRefreshCounter } from '@morning-dashboard/hooks/useRefreshCounter';
import { AddBtn } from '../add-btn';
import { CardLinks } from '../card-links';
import { DragButton } from '../drag-btn';
import { useWidgetCard } from '../widget-card/WidgetCardContext';
import { BoxKey, BOXTYPE_ENUM } from '@morning-dashboard/MorningDashboard.types';
import { Box } from '../../../../../theme/fluent';

export type CardHeaderProps = {
  type?: BoxKey;
  title?: string;
  description?: string;
  links?: { label?: string; url?: string }[];
  add?: () => void | undefined;
  addDisabled?: boolean;
  loading?: boolean;
};

const CardHeader = React.forwardRef<HTMLElement, CardHeaderProps>(
  ({ loading, type, title, description, links, add, addDisabled }, ref) => {
    const DEFAULT_HEADER_HEIGHT = 48; // default height when there is no description and links
    const { isCustomizeOpened } = useRefreshCounter();
    const { classes, addBtnStyle, addBtnDisabledStyle, addBtnStyleRadius, descriptionColorStyle } =
      useMorningDashBoardCardHeaderStyles();
    const { cardHeaderHeight } = useWidgetCard();
    const itemsPosition = cardHeaderHeight > DEFAULT_HEADER_HEIGHT ? classes.flexStart : classes.flexEnd;
    const mergedRightContentClass = mergeClasses(classes.rightContent, itemsPosition);

    return (
      <Box
        ref={ref}
        {...devComponentName('CardHeader')}
        className={mergeClasses(classes.root, add ? classes.addButton : undefined)}
      >
        <Box className={classes.leftContent}>
          {title}
          {description && type !== BOXTYPE_ENUM.calendar && (
            <Box className={classes.description} style={descriptionColorStyle}>
              {description}
            </Box>
          )}
          {type === BOXTYPE_ENUM.calendar && (
            <Box className={classes.description} style={descriptionColorStyle}>
              {getTodayDate()}
            </Box>
          )}
        </Box>
        <Box className={mergedRightContentClass}>
          {links?.length && !isCustomizeOpened && <CardLinks links={links} />}
          {add !== undefined && !isCustomizeOpened && (
            <AddBtn
              style={{ ...addBtnStyleRadius, ...(loading || addDisabled ? addBtnDisabledStyle : addBtnStyle) }}
              onClick={add}
              disabled={loading || addDisabled}
            />
          )}
          <DragButton />
        </Box>
      </Box>
    );
  },
);

CardHeader.displayName = 'CardHeader';
export default CardHeader;
